import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";

import "./index.scss";
import { PhoneFIcon } from "../../../assets/icons/PhoneFIcon";
import { WhatsappFIcon } from "../../../assets/icons/whatsappFIcon";
import { EmailFIcon } from "../../../assets/icons/EmailFIcon";
import { LinkendIcon } from "../../../assets/icons/LinkendIcon";
import { FacebookIcon } from "../../../assets/icons/FacebookIcon";
import { TwiterIcon } from "../../../assets/icons/TwiterIcon";
import NewslettreService from "../../../services/newsletter/newslettre.service";
import { showErrorToaster } from "../../toaster/error";
import { showSuccessToaster } from "../../toaster/success";
const newslettreService = new NewslettreService();
const Footer = () => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  // Fonction de notification d'erreur

  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Vérification de l'email
    if (!email) {
      setEmailError("Le champ email est obligatoire.");
      showErrorToaster("Le champ email est obligatoire.");
    } else if (!isValidEmail(email)) {
      setEmailError("Veuillez entrer un email valide.");
      showErrorToaster("Veuillez entrer un email valide.");
    } else {
      try {
        // Préparer les données à envoyer
        const data = { email };

        // Appeler la méthode du service pour ajouter la formation
        await newslettreService.addNewslettre(data);

        // Afficher le toast de succès
        showSuccessToaster("Inscription réussie à la newsletter");

        // Réinitialiser le champ et l'erreur
        setEmail("");
        setEmailError("");
      } catch (error) {
        // Afficher le toast d'erreur
        showErrorToaster(
          error.response
            ? error.response.data.message
            : "Une erreur est survenue, veuillez réessayer."
        );
      }
    }
  };
  return (
    <footer className="footer-section">
      <div className="top-bar">
        <Container>
          <Row className="justify-content-between align-items-center">
            <Col xs={12} md={4} className="contact-item">
              <PhoneFIcon className="icon" /> &nbsp; 01 71 36 24 89
            </Col>
            <Col xs={12} md={4} className="contact-item ">
              <WhatsappFIcon className="icon" />
              &nbsp; WhatsApp
            </Col>
            <Col xs={12} md={4} className="contact-item">
              <EmailFIcon className="icon" />
              &nbsp; contact@habitat-idf.fr
            </Col>
          </Row>
        </Container>
      </div>

      <div className="main-footer ">
        <div className="text-center ">
          <h2>Bento Habitat</h2>
          <p>
            Experts en rénovation énergétique et ravalement en Île-de-France
          </p>

          <Form className="newsletter-form d-flex justify-content-center">
            <div className="newsletter-wrapper d-flex">
              <Form.Control
                type="email"
                placeholder="Votre adresse email"
                className="email-input"
                value={email}
                onChange={handleEmailChange}
              />
              <Button
                type="submit"
                className="subscribe-btn"
                onClick={handleSubmit}>
                <strong>Inscription</strong>
              </Button>
            </div>
          </Form>
          <nav className="footer-nav mt-md-5 mt-3">
            <a href="/">Accueil</a>
            <a href="/apropos">À propos</a>
            <a href="/services">Services</a>
            <a href="/blogs">Blogs</a>
          </nav>
          <div className="d-flex justify-content-between   footer-content">
            <p className="copyright mt-4">
              © 2025 bento habitat. Tous droits réservés
            </p>

            <div className="social-icons mt-4">
              <a href="#">
                <LinkendIcon />
              </a>
              <a href="#">
                <FacebookIcon />
              </a>
              <a href="#">
                <TwiterIcon />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
